import { dispatcher } from '../dispatcher/dispatcher';
import Constants from '../constants/constants';
const { ActionTypes } = Constants;
import { ServerActions } from '../actions/serverActions';
import { SchematicAPI } from '../actions/schematicAPI';
import { PrintSchematicActions } from '../actions/printSchematicActions';

var STATUS = Constants.RestrictionStatuses;
export const SubdivisionActions = {

    /**
     *
     * @param selectedSub
     * @param token
     */
    selectChanged: function (selectedSub) {
        dispatcher.dispatch({
            type: ActionTypes.SUBDIVISION_CHANGED,
            selectedSub: selectedSub,
        });

        ServerActions.getSubdivisionDetails(selectedSub);

        SchematicAPI.setSubdivision(selectedSub).then(function (response) {
            SchematicAPI.showAllLayers();
            console.log("Set subdivision for Main Schematic");

            PrintSchematicActions.setSubdivision(selectedSub).then(function (response) {
                PrintSchematicActions.showAllLayers();
                console.log("Set subdivision for Print Schematic");
            }).catch(function (e) {
                console.log("Failed to set subdivision for Print Schematic: ", e);
            });
        }).catch(function (e) {
            console.log("Failed to set subdivision for Main Schematic: ", e);
        });
    },
};
